import { Card, Row } from "antd";
import { useParams } from "react-router-dom";
import { Header } from "../Documents/components/Header";
import { SendForm } from "./compenents/Forms/SendForm";
import { Requests } from "./compenents/Requests";
import { useCallback, useMemo, useState } from "react";
import { useFetchExternalPortalAccountData } from "../../lib/hooks/useFetchExternalPortalAccountData";
import { Loader } from "../../components/Loader";
import { Error } from "../../components/Error";
import { NavigateFunction, useNavigate } from "react-router-dom";
import EXTERNAL_USER_CONTRACT_ROLES from "../../types/enums/ExternalUserContractRole";
import "./styles.scss";

export const RequestsAndForms = () => {
  const { accountId } = useParams();

  const accountNumber: number = useMemo(() => {
    return accountId ? +accountId : NaN;
  }, [accountId]);

  const [error, setError] = useState<string | null>(null);

  const navigate: NavigateFunction = useNavigate();

  const accessibleRoles = useMemo(
    () => [
      EXTERNAL_USER_CONTRACT_ROLES.PrimaryBuyer,
      EXTERNAL_USER_CONTRACT_ROLES.PrimarySeller,
    ],
    [],
  );

  const { roleInfo, isLoading } = useFetchExternalPortalAccountData(
    accountNumber,
    setError,
    accessibleRoles,
  );

  const onBackButtonClicked = useCallback(() => navigate(-1), [navigate]);

  return (
    <Row className="d-block page-content doc-page">
      {error ? (
        <Error
          accountNumber={accountNumber}
          error={error || ""}
          showHeader
          onBackButtonClicked={onBackButtonClicked}
        />
      ) : (
        <>
          {isLoading ? (
            <Row className="w-100 justify-center h-100">
              <Loader fontSize="128px" />
            </Row>
          ) : (
            <>
              {accountId && (
                <Header title="Requests & Forms" accountId={accountId} />
              )}
              <Row className="justify-center py-6 w-100 doc-wrapper overflow-y-auto">
                <Row className="requests">
                  {roleInfo.isBuyer && (
                    <Requests contractNumber={accountId || ""} />
                  )}
                  <Card className="mx-4 w-100 mobile-hidden">
                    <SendForm contractNumber={accountId || ""} />
                  </Card>
                </Row>
              </Row>
            </>
          )}
        </>
      )}
    </Row>
  );
};
